import { Button, Icon, Checkbox, FormControl, Grid, InputLabel, MenuItem, Paper, Select, Tab, Tabs, TextField, Typography, makeStyles, Tooltip, Box } from '@material-ui/core';
import React from 'react';
import { ITableCommonToolbar, TableCommon } from '../../../shared/components/TableCommon';
import { TableLoading } from '../../../shared/components/TableLoading';
import { BasicConfirmDialog } from '../../../shared/components/BasicConfirmDialog';
import { HomeContext } from '../../Home/HomeContext';
import { AuthContext } from '../../Authentication/AuthContext';
import { HistoryLocation } from '../enum/HistoryLocation';
import { PageLocation } from '../../../shared/enum/PageLocation';
import { NewsStatus } from '../enum/NewsStatus';
import InfluencerSpreadsheetService from '../../../Services/InfluencerService';
import { InfluencerSpreadsheetModel, InfluencerSpreadsheetModelInitial } from '../../../Models/InfluencerSpreadSheetModel';
import { AxiosError, AxiosResponse } from 'axios';
import { getTableColumn } from '../../../shared/operators';
import { Action, Column, Options } from 'material-table';
import { TableEmpty } from '../../../shared/components/TableEmpty';
import { NewsOrigin } from '../../../shared/enum/NewsOrigin';
import { theme } from '../../../theme';
import InfluencerService from '../../../Services/InfluencerService';
import { InfluencerModel } from '../../../Models/InfluencerModel';
import InfluencerClassificationFilters from '../components/InfluencerClassificationFilters';
import { useInputStyles } from '../../../shared/components/UploadStyles';
import { InfluencerAuxiliarModel, InfluencersAuxiliarResponse } from '../../../Models/InfluencerAuxiliarModel';
import { DatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import { MaterialUiPickersDate } from '@material-ui/pickers/typings/date';
import { ptBR } from 'date-fns/locale';
import DateFnsUtils from '@date-io/date-fns';
import { InfluencerContext } from '../../ClassificationInfluencer/NewsContext';
import InfluencerTextFilter from '../components/InfluencerTextFilter';
import InfluencerUrlFilter from '../components/InfluencerUrlFilter';
import { TableCommonWithValidate } from '../../../shared/components/TableCommonWithValidate';
import { StatusUpload } from '../../../shared/enum/StatusUpload';
import { UploadLoading } from '../../../shared/components/UploadLoading';
import { InfluencerUploadResult } from './InfluencerUploadResult';
import { InfluencerUploadResultInitial, InfluencerUploadResultModel } from '../../../Models/InfluencerUploadResultModel';
import { InfluencerAutorizationResult } from './InfluencerAutorizationResult';
import { StatusResult } from '../../../shared/enum/StatusResult';
import { IErrorResponse } from '../../../shared/ErrorResponse';
import { ErrorHelper } from '../../../shared/ErrorHelper';
import { CampaignModel } from '../../../Models/CampaignModel';
import InfluencerCompanyService from '../../../Services/InfluencerCompanyService';

export interface IHistoryClassificationProps {
    handlePageLocation: (location: PageLocation) => void;
}

const useStyles = makeStyles((theme) => ({
    root: {
        padding: theme.spacing(1.5, 4),
        width: '100%',
        maxWidth: '1800px'
    },
    title: {
        margin: '20px 0px 32px'
    },
    titleContainer: {
        marginBottom: theme.spacing(3)
    },
    tabs: {
        justifyContent: 'space-between',
        display: 'flex'
    },
    addNewButtonGrid: {
        justifyItems: 'center'
    },
    emptyTable: {
        display: 'flex',
        justifyContent: 'center',
        width: '100%',
        maxWidth: '1800px',
        padding: theme.spacing(0, 4)
    },
    whiteTooltip: {
        backgroundColor: '#fff',
        color: '#000',
        boxShadow: theme.shadows[1],
        fontSize: 12,
        maxWidth: 400,
        border: '1px solid #ccc',
    },
}));
export default function InfluencerCampaignClassification() {
    const classesInput = useInputStyles();
    const classes = useStyles();

    const authContext = React.useContext(AuthContext);
    const homeContext = React.useContext(HomeContext);
    const newsContext = React.useContext(InfluencerContext);
    const clientEnable = homeContext.influencerClientEnable;
    const [status, setStatus] = React.useState<StatusUpload>(StatusUpload.INPUT);
    const [resultUpload, setResultUpload] = React.useState<InfluencerUploadResultModel>(InfluencerUploadResultInitial);
    const [file, setFile] = React.useState<InfluencerModel | null>(null);



    const [historyType, setHistoryType] = React.useState<HistoryLocation>(HistoryLocation.PENDING);
    const [spreadsheets, setSpreadsheets] = React.useState<InfluencerSpreadsheetModel[]>([]);
    const [filters, setFilters] = React.useState<InfluencersAuxiliarResponse>();
    const [filterDate, setFilterDate] = React.useState<Date | null>(null);
    const [filterRequestor, setFilterRequestor] = React.useState<number | null>();
    const [filterResponsavelReputacao, setFilterResponsavelReputacao] = React.useState<number | null>();
    const [filterStatus, setFilterStatus] = React.useState<number | null>();
    const [filterBrand, setFilterBrand] = React.useState<number | null>();
    const [filterArea, setFilterArea] = React.useState<number | null>();
    const [filterVp, setFilterVp] = React.useState<number | null>();
    const [filterNomeInfluenciador, setFilterNomeInfluenciador] = React.useState<string>('');
    const [filterUrl, setFilterUrl] = React.useState<string>('');
    const [showConfirmDelete, setShowConfirmDelete] = React.useState(false);
    const [influencerDelete, setinfluencerDelete] = React.useState<InfluencerSpreadsheetModel>(InfluencerSpreadsheetModelInitial);

    const [influencerValidacao, setinfluencerValidacao] = React.useState<InfluencerSpreadsheetModel>(InfluencerSpreadsheetModelInitial);
    const [loading, setLoading] = React.useState(true);

    React.useEffect(() => {
        setLoading(true);
        if (clientEnable) {
            if (historyType == HistoryLocation.PENDING) {
                InfluencerCompanyService.getCompanyByClient(clientEnable.id_cliente)
                    .then((res: AxiosResponse) => { setSpreadsheetsData(res.data); })
                    .catch((error: AxiosError) => { homeContext.showError('', error); });

                InfluencerService.getInfluencersBrandByClient(clientEnable.id_cliente)
                    .then((res: AxiosResponse) => {
                        setFiltersData(res.data);
                    })
                    .catch((error: AxiosError) => { homeContext.showError('', error); });

            } else
                setLoading(false);
        }
    }, [historyType, status]);

    const setSpreadsheetsData = (data: InfluencerSpreadsheetModel[]) => {
        setSpreadsheets(data);

        if (filters !== null && spreadsheets) {
            setLoading(false);
        }
    };

    const setFiltersData = (data: InfluencersAuxiliarResponse) => {
        setFilters(data);
    };

    const getNivelRiscoIcon = (nivel: string) => {
        const normalized = nivel?.toLowerCase();
        switch (normalized) {
            case 'baixo':
                return (
                    <Tooltip title="Baixo: Não há registros ou sensibilidades que representem risco reputacional ao Grupo.">
                        <Box display="flex" alignItems="center">
                            <Icon style={{ color: 'green', marginRight: 4 }}>check_circle</Icon>
                            <span>Baixo</span>
                        </Box>
                    </Tooltip>
                );
            case 'moderado':
                return (
                    <Tooltip title="Moderado: Foi(ram) identificada(s) sensibilidade(s) com possível impacto reputacional ao Grupo.">
                        <Box display="flex" alignItems="center">
                            <Icon style={{ color: 'goldenrod', marginRight: 4 }}>warning</Icon>
                            <span>Moderado</span>
                        </Box>
                    </Tooltip>
                );
            case 'alto':
                return (
                    <Tooltip title="Alto: Foram identificadas sensibilidades que apresentam alto risco reputacional ao Grupo.">
                        <Box display="flex" alignItems="center">
                            <Icon style={{ color: 'red', marginRight: 4 }}>error</Icon>
                            <span>Alto</span>
                        </Box>
                    </Tooltip>
                );
            case 'crítico':
            case 'critico':
                return (
                    <Tooltip title="Crítico: Foram identificadas sensibilidades que apresentam risco reputacional severo ao Grupo. Não recomendamos a realização.">
                        <Box display="flex" alignItems="center">
                            <Icon style={{ color: 'darkred', marginRight: 4 }}>highlight_off</Icon>
                            <span>Crítico</span>
                        </Box>
                    </Tooltip>
                );
            default:
                return nivel;
        }
    };

    const tableColumns: Column<CampaignModel>[] = [
        getTableColumn('Empresa/Evento/Patrocínio', 'nome', 'string', 'left', undefined, undefined, false),
        getTableColumn('Marca', 'marca', 'string', 'left', undefined, undefined, false),
        getTableColumn('Nome Solicitante', 'solicitante', 'string', 'left', undefined, undefined, false),
        {
            title: (
                <Tooltip
                    title={
                        <div style={{ lineHeight: 1.6 }}>
                            <div><Icon style={{ color: 'green', fontSize: 16, verticalAlign: 'middle' }}>check_circle</Icon> <b>Baixo</b>: Não há registros ou sensibilidades que representem risco reputacional ao Grupo.</div>
                            <div><Icon style={{ color: 'goldenrod', fontSize: 16, verticalAlign: 'middle' }}>warning</Icon> <b>Moderado</b>: Sensibilidade(s) com possível impacto reputacional ao Grupo.</div>
                            <div><Icon style={{ color: 'red', fontSize: 16, verticalAlign: 'middle' }}>error</Icon> <b>Alto</b>: Sensibilidades que apresentam alto risco reputacional.</div>
                            <div><Icon style={{ color: 'darkred', fontSize: 16, verticalAlign: 'middle' }}>highlight_off</Icon> <b>Crítico</b>: Risco reputacional severo. Não recomendamos a realização.</div>
                        </div>
                    }
                    arrow
                    placement="top"
                    classes={{ tooltip: classes.whiteTooltip }}
                >
                    <span>Nível de Risco</span>
                </Tooltip>
            ),
            field: 'nivelRisco',
            type: 'string',
            align: 'left',
            filtering: false,
            cellStyle: { whiteSpace: 'nowrap' },
            render: (rowData: CampaignModel) => getNivelRiscoIcon(rowData.nivelRisco)
        },
        {
            title: 'Data Submissão',
            field: 'dataRecebimento',
            type: 'datetime',
            align: 'left',
            filtering: false,
            dateSetting: { locale: 'pt-BR' },
            defaultSort: 'desc',
            cellStyle: { minWidth: '190px' }
        },

    ];

    const pendingTableToolbarText: ITableCommonToolbar = {
        title: '   ',
        subtitle: ' '
    };

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const pendingTableActions: (Action<any> | ((rowData: any) => Action<any>))[] = [
        {
            icon: 'edit',
            iconProps: { style: { fontSize: '20px' } },
            tooltip: 'Classificar',
            onClick: (_, rowData: InfluencerModel) => {
                homeContext.setSpreadsheetId(rowData.id);
                newsContext.setNewsCurrentId(rowData.id);
                newsContext.setNews(rowData);
                homeContext.setPageLocation(PageLocation.INFLUENCER_COMPANY_CLASSIFICATION);
            }
        },
        rowData => ({
            icon: 'delete_outline',
            iconProps: { style: { fontSize: '20px' } },
            tooltip: 'Excluir inflcuenciador',
            onClick: (_, rowData: InfluencerSpreadsheetModel) => {
                setinfluencerDelete(rowData);
                setShowConfirmDelete(true);
            },
            disabled: rowData.newsByStatus != rowData.totalInfluencer,
            hidden: rowData.newsByStatus != rowData.totalInfluencer
        }),
    ];

    const deleteInfluencer = () => {
        setShowConfirmDelete(false);
        setHistoryType(HistoryLocation.CLASSIFIED);
        setLoading(true);
        InfluencerCompanyService.deleteCompanyById(influencerDelete.id)
            .then(() => {
                //  window.location.reload();
                setHistoryType(HistoryLocation.PENDING);
            });
    };



    const setFilterNull = () => {
        setFilterDate(null);
        setFilterRequestor(undefined);
        setFilterStatus(undefined);
        setFilterBrand(undefined);
        setFilterArea(undefined);
        setFilterVp(undefined);
        setFilterResponsavelReputacao(undefined);
        setFilterNomeInfluenciador('');
        setFilterUrl('');

        // Refaz a busca dos dados originais após limpar os filtros
        setLoading(true);
        if (clientEnable) {
            InfluencerCompanyService.getCompanyByClient(clientEnable.id_cliente)
                .then((res: AxiosResponse) => { setSpreadsheetsData(res.data); })
                .catch((error: AxiosError) => { homeContext.showError('', error); });
        }
    };

    const getEmptyTable = (historyLocation: HistoryLocation, displayText: string) => {
        if (historyType == historyLocation && spreadsheets.length == 0 && !loading) {
            return (
                <Grid
                    container
                    spacing={3}
                    direction="column"
                    alignItems="center">
                    <Grid item className={classes.emptyTable}>
                        <TableEmpty displayText={displayText} />
                    </Grid>

                </Grid>
            );
        }
    };

    const getFiltersInfluencers = () => {
        setLoading(true);
        if (clientEnable) {
            InfluencerCompanyService.getCompanyByClient(clientEnable.id_cliente,
                {
                    data_hora_receipt: filterDate,
                    marca: filterBrand,
                    solicitante: filterRequestor,
                    area: filterArea,
                    responsavel_reputacao: filterResponsavelReputacao,
                    nome: filterNomeInfluenciador,
                    url: filterUrl,
                    vp: filterVp,
                }
            )
                .then((res: AxiosResponse) => {
                    if (res.data.length == 0) {
                        setSpreadsheetsData([]);
                    }
                    else {
                        setSpreadsheetsData(res.data);
                    }
                    setSpreadsheetsData(res.data);
                })
                .catch((error: AxiosError) => { homeContext.showError('', error); });
        }
    };

    const inputTitleAndSubtitle = () => {
        return (
            <Grid
                container
                spacing={1}
                className={classes.titleContainer}
            >
                <Grid
                    item
                    xs={12}
                >
                    <Typography variant="h4">
                        Listagem de Empresas, Eventos e Patrocínios
                    </Typography>
                </Grid>
            </Grid>
        );
    };


    return (
        <>
            {status === StatusUpload.INPUT && (
                <>
                    <Grid container justify="center">
                        <Grid
                            container
                            className={classes.root}
                            justify="flex-start"
                            direction="column">
                            {/* {getTitleAndSubtitle()} */}
                            {filters && (
                                <Grid
                                    container
                                    className={classes.root}
                                    direction="column"
                                >
                                    {inputTitleAndSubtitle()}
                                    <Paper
                                        style={{
                                            borderRadius: '8px',
                                            width: '100%',
                                            // overflowX: 'auto'
                                        }}
                                    >
                                        <Grid
                                            container
                                            direction="row"
                                            className={classes.root}
                                            spacing={4}
                                        >
                                            <Grid item
                                                style={{
                                                    outline: 'none',
                                                    borderBottom: 'none',
                                                }}
                                            >


                                                <Grid container style={{ marginTop: '0.5rem', marginBottom: '0.5rem', border: '1px solid #ccc', padding: '8px', borderRadius: '4px' }}>
                                                    <Grid item xs={9}>
                                                        <MuiPickersUtilsProvider locale={ptBR} utils={DateFnsUtils}>
                                                            <DatePicker
                                                                id="news-date"
                                                                variant="inline"
                                                                value={filterDate}
                                                                inputVariant="standard"
                                                                label="Data de Recebimento"
                                                                minDate={new Date(0)}
                                                                onChange={(date) => setFilterDate(date ?? null)}
                                                                InputProps={{
                                                                    readOnly: true,
                                                                }}
                                                                format="dd/MM/yyyy"
                                                            />
                                                        </MuiPickersUtilsProvider>
                                                    </Grid>
                                                    <Grid item xs={3} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                        <Button onClick={() => setFilterDate(null)} variant="text" fullWidth style={{ height: '100%' }}
                                                            onMouseOver={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
                                                            onMouseOut={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
                                                        >
                                                            <Icon>delete_outline</Icon>
                                                        </Button>
                                                    </Grid>
                                                </Grid>

                                            </Grid>

                                            <InfluencerClassificationFilters size={3} key={filterRequestor} items={filters.solicitantes} Title={'Nome Solicitante'} selectValue={filterRequestor} setSelectValue={setFilterRequestor} />
                                            <InfluencerClassificationFilters size={3} key={filterBrand} items={filters.marcas} Title={'Marca'} selectValue={filterBrand} setSelectValue={setFilterBrand} />
                                            <InfluencerClassificationFilters size={3} key={filterArea} items={filters.area} Title={'Área'} selectValue={filterArea} setSelectValue={setFilterArea} />
                                            <InfluencerClassificationFilters size={3} key={filterVp} items={filters.vp} Title={'VP'} selectValue={filterVp} setSelectValue={setFilterVp} />
                                            <InfluencerClassificationFilters size={3} key={filterResponsavelReputacao} items={filters.responsavel_reputacao}
                                                Title={'Responsável Reputação'} selectValue={filterResponsavelReputacao} setSelectValue={setFilterResponsavelReputacao} />
                                            <InfluencerTextFilter size={3} titulo='Nome da empresa ou evento' value={filterNomeInfluenciador} setValue={setFilterNomeInfluenciador} />
                                        </Grid>
                                        <Grid
                                            container
                                            direction="row"
                                            justifyContent="flex-end"
                                        >
                                            <Button
                                                size="large"
                                                variant="contained"
                                                color="inherit"
                                                style={{
                                                    width: '180px',
                                                    margin: '20px',
                                                }}
                                                onClick={() => setFilterNull()}
                                            >
                                                Limpar Filtro
                                            </Button>

                                            <Button
                                                size="large"
                                                variant="contained"
                                                color="primary"
                                                style={{
                                                    width: '180px',
                                                    margin: '20px',
                                                }}
                                                onClick={getFiltersInfluencers}
                                            >Buscar</Button>
                                        </Grid>
                                    </Paper>
                                </Grid>
                            )}
                            {spreadsheets.length > 0 && !loading && (
                                <>
                                    <Grid
                                        container
                                        className={classes.root}
                                        direction="column"
                                    >
                                        <TableCommon
                                            tableData={spreadsheets}
                                            tableColumns={tableColumns}
                                            emptyDataSourceMessage='Nenhuma Empresa encontrada para esse filtro.'
                                            tableActions={pendingTableActions}
                                            toolbar={pendingTableToolbarText}
                                            style={{ padding: theme.spacing(0, 11) }} />
                                    </Grid>
                                </>

                            )}
                            {loading &&
                                <TableLoading displayText="Carregando histórico" />}

                            {!loading && getEmptyTable(HistoryLocation.PENDING, 'Nenhuma Empresa encontrado.')}
                        </Grid>
                    </Grid>
                    <BasicConfirmDialog
                        title={'Tem certeza que deseja excluir?'}
                        description={
                            influencerDelete && influencerDelete.newsOrigin == NewsOrigin.SpreadsheetImport
                                ? 'Ao excluir esta Empresa você não poderá classifica-la.'
                                : 'Ao excluir esta Empresa você não poderá classifica-la.' +
                                'não será possível obtê-la novamente.'}
                        handleFirstButton={deleteInfluencer}
                        handleSecondButton={() => setShowConfirmDelete(false)}
                        textFirstButton={'Excluir'}
                        textSecondButton={'Cancelar'}
                        open={showConfirmDelete} />
                </>
            )}

        </>
    );


}